<template>
  <div>
    <v-stepper flat class="borderless shadowless" value="1">
      <v-stepper-header flat class="borderless shadowless">
        <v-stepper-step step="1">Détails préliminaires</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">Ajouter le responsable et l'organisateur de l'évènement</v-stepper-step>
        <v-divider></v-divider>
        <!-- <v-stepper-step step="3">Ajouter les participants</v-stepper-step> -->
        <!-- <v-divider></v-divider>
        <v-stepper-step step="4">Notification de rappel</v-stepper-step> -->
      </v-stepper-header>
    </v-stepper>

    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">{{ snackbar_message
      }}</v-snackbar>

    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="newEvent1()" class="mt-3">
      <v-card flat>
        <v-card-title>
          <h6 class="primary--text">Informations sur l'activité</h6>
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs6 sm4>
                <v-subheader>Nom de l'évènement</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field v-model="event.name" :rules="nameRules" label="Nom de l'évènement" clearable
                  solo></v-text-field>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Objectif de l'évènement</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field v-model="event.objective" :rules="objectiveRules" label="Objectif de l'évènement"
                  clearable solo></v-text-field>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Type d'évènement</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-select v-model="event.event_type_id" :items="types" item-text="name" item-value="id" item-key="id"
                  @change="loadThematics()" :rules="[v => !!v || 'Type requis']" label="Type" clearable solo></v-select>
              </v-flex>

              <v-flex xs6 sm4 v-if="event.event_type_id && selectedType && filteredThematics.length > 0">
                <v-subheader>Thématique de formation </v-subheader>
              </v-flex>
              <v-flex xs6 sm8 v-if="event.event_type_id && selectedType && filteredThematics.length > 0">
                <v-select v-model="event.thematic_type_id" :items="filteredThematics" item-text="name" item-value="id"
                  item-key="id" label="Thématique" clearable solo></v-select>
              </v-flex>



              <!-- <v-flex xs6 sm4>
                <v-subheader>MOV</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field v-model="event.mov" :rules="movRules" label="MOV" clearable solo></v-text-field>
              </v-flex> -->

              <v-flex xs6 sm4>
                <v-subheader>Chaine de valeur</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-select v-model="tab_chain_ids" :items="value_chains" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Chaine de valeur requise']" label="Chaine de valeur" clearable solo chips
                  multiple></v-select>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Domaine</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-select v-model="event.domain_id" :items="domains" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Domaine requis']" label="Domaine" clearable solo></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <v-card class="mt-5" flat>
        <v-card-title>
          <h6 class="primary--text">Date et lieu de tenu</h6>
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs6 sm4>
                <v-subheader>Pays</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="event.country_id" :items="countries" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Pays requis']" label="Pays" @input="chooseDepartement()" clearable
                  solo></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Département</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="event.department_id" :items="departments" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Département requis']" label="Département" @input="chooseMunicipality()"
                  clearable solo></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Commune</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="event.municipality_id" :items="municipalities" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Commune requise']" label="Commune" @input="chooseDistrict()" clearable
                  solo></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Arrondissement</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="event.district_id" :items="districts" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Arrondissement requis']" label="Arrondissement" @input="chooseTown()" clearable
                  solo></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Village</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-autocomplete v-model="event.town_id" :items="towns" item-text="name" item-value="id"
                  :rules="[v => !!v || 'Village requis']" label="Village" clearable solo></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Date de l'évènement</v-subheader>
              </v-flex>
              <v-flex xs4 sm4>
                <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="eventDateMoment" clearable label="Date de début" readonly v-on="on"
                      prepend-icon="mdi-calendar" solo></v-text-field>
                  </template>
                  <!-- <v-date-picker
                    v-model="event_date"
                    :min="allowedDateStart"
                    @input="menu1 = false"
                  ></v-date-picker> -->
                  <v-date-picker v-model="event_date" @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs3 sm3 offset-xs1>
                <v-menu v-model="menu3" :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="eventDateEndMoment" clearable label="Date de fin" readonly v-on="on"
                      solo></v-text-field>
                  </template>
                  <!-- <v-date-picker
                    v-model="event_date_end"
                    :min="allowedDateEnd"
                    @input="menu3 = false"
                  ></v-date-picker> -->
                  <v-date-picker v-model="event_date_end" @input="menu3 = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Heure</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                  :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="time" label="Heure de l'évènement" prepend-icon="mdi-timetable" v-on="on"
                      solo clearable></v-text-field>
                  </template>
                  <v-time-picker v-if="menu2" v-model="time" format="24hr" @click:minute="$refs.menu.save(time)"
                    solo></v-time-picker>
                </v-menu>
              </v-flex>

              <v-flex xs6 sm4>
                <v-subheader>Lieu</v-subheader>
              </v-flex>
              <v-flex xs6 sm8>
                <v-text-field v-model="event.place" :rules="placeRules" label="Lieu" clearable solo></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <div class="text-center mt-1">
        <v-btn rounded color="primary" type="submit" v-if="$can('create events')">Enregistrer et Continuer</v-btn>
      </div>
    </v-form>
    <br />
    <br />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Permissions from '~/mixins/Permissions'

export default {
  name: 'create-event',
  mixins: [Permissions],
  data: () => ({
    event: {},
    tab_chain_ids: [],
    valid: false,
    nameRules: [v => !!v || 'Nom requis'],
    objectiveRules: [v => !!v || "Objectif de l'évènement requis"],
    // movRules: [v => !!v || "MOV requis"],
    placeRules: [v => !!v || "Lieu de l'évènement requis"],

    event_date: null,
    event_date_end: null,
    menu1: false,
    menu2: false,
    menu3: false,
    time: null,
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',
    selectedType: null,
  }),

  computed: {

    authUser() {
      return this.$store.getters.authUser
    },
    value_chains() {
      return this.$store.getters.getValueChains
    },
    domains() {
      return this.$store.getters.getDomains
    },
    types() {
      return this.$store.getters.event_types
    },

    countries() {
      return this.$store.getters.getCountries
    },
    departments() {
      return this.$store.getters.getDepartments
    },
    municipalities() {
      return this.$store.getters.getMunicipalities
    },
    districts() {
      return this.$store.getters.getDistricts
    },
    towns() {
      return this.$store.getters.getTowns
    },
    filteredThematics: {
      // getter
      get: function () {
        if (this.event.event_type_id == '' || this.selectedType == null) {
          return this.$store.getters.thematic_types
        } else {
          return this.$store.getters.thematic_types.filter(thematic => thematic.event_type_id === this.selectedType.id)
        }

      },
    },
    eventDateMoment() {
      return this.event_date
        ? this.$moment(this.event_date).format('D MMMM YYYY')
        : ''
    },

    eventDateEndMoment() {
      return this.event_date_end
        ? this.$moment(this.event_date_end).format('D MMMM YYYY')
        : ''
    },

    allowedDateStart() {
      const aujourdhui = this.$moment(new Date()).format('YYYY-MM-DD')
      return aujourdhui
    },

    allowedDateEnd() {
      const aujourdhui = this.$moment(new Date()).format('YYYY-MM-DD')
      return aujourdhui
    }
  },

  created() {
    this.$checkPermission('create events')
    this.fetchUtils()
  },

  mounted() {
    this.checkRegistering()
    this.getLocation()
  },
  watch: {
    'event.type'(newVal, oldVal) {
      if (newVal && oldVal) {
        if (newVal != oldVal) {
          this.event.thematic_type_id = null
        }
      }
    },
  },

  methods: {
    fetchUtils() {
      this.$store.dispatch("fetchThematicTypes");
      this.$store.dispatch('loadCountries')
      this.$store.dispatch('loadValueChains')
      this.$store.dispatch('loadDomains')
      this.$store.dispatch('fetchEventTypes')
    },

    checkRegistering() {
      var new_event = this.$store.getters.getNewEvent
      if (new_event != null) {
        this.event.name = new_event.name
        this.event.objective = new_event.objective
        this.event.type = new_event.type
        this.event.domain_id = new_event.domain_id
        this.event.country_id = new_event.country_id
        this.event.department_id = new_event.department_id
        this.event.municipality_id = new_event.municipality_id
        this.event.district_id = new_event.district_id
        this.event.place = new_event.place
        this.tab_chain_ids = new_event.chain_ids

        /* let tab = new_event.event_date.split(' ');
        this.event_date = tab[0];
        this.time = tab[1];
*/
        this.event_date = new_event.event_date
        this.event_date_end = new_event.event_date_end
        this.time = new_event.event_time
      }
    },
    loadThematics() {
      this.selectedType = this.types.find(type => type.id === this.event.event_type_id);
    },
    chooseDepartement() {
      const pays = this.event.country_id
      this.$store.dispatch('loadDepartments', pays)
    },

    chooseMunicipality() {
      const departement = this.event.department_id
      this.$store.dispatch('loadMunicipalities', departement)
    },

    chooseDistrict() {
      const commune = this.event.municipality_id
      this.$store.dispatch('loadDistricts', commune)
    },

    chooseTown() {
      const arrond = this.event.district_id
      this.$store.dispatch('loadTowns', arrond)
    },

    newEvent1() {

      this.event.event_date = this.event_date
      this.event.event_date_end = this.event_date_end
      this.event.event_time = this.time
      if (
        this.event.name == null ||
        this.event.objective == null ||
        this.event.event_type_id == null ||
        this.tab_chain_ids == null ||
        this.event.domain_id == null ||
        this.event.event_date == null ||
        this.event.event_date_end == null ||
        this.time == null ||
        this.event.place == null ||
        this.event.country_id == null ||
        this.event.department_id == null ||
        this.event.municipality_id == null ||
        this.event.district_id == null ||
        this.event.town_id == null
      ) {
        this.snackbar = true
        this.snackbar_color = 'error'
        this.snackbar_message =
          'Veuillez remplir tous les champs avant de poursuivre'
        return
      } else if (this.event_date_end < this.event_date) {
        this.snackbar = true
        this.snackbar_color = 'error'
        this.snackbar_message = "La date de fin ne peut pas être antérieure à la date de début.";
      } else {

        this.event.chain_ids = this.tab_chain_ids
        this.$store.dispatch('storeEvent1', this.event)
        this.$router.push({
          name: 'events.new-2',
          params: { first_next: true }
        })
      }
    },

    getLocation() {
      if ('geolocation' in navigator) {
        var geo_options = {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 27000
        }
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError, geo_options)
      } else {
        this.$dialog.message.error('Geolocation is not supported by this browser.', {
          position: 'top-center'
        })
      }
    },
    showPosition(position) {
      this.event.latitude = position.coords.latitude
      this.event.longitude = position.coords.longitude
      this.event.altitude = position.coords.altitude
      this.event.precision = position.coords.accuracy
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.$dialog.message.error('User denied the request for Geolocation.', {
            position: 'top-center'
          })
          break
        case error.POSITION_UNAVAILABLE:
          this.$dialog.message.error('Location information is unavailable.', {
            position: 'top-center'
          })
          break
        case error.TIMEOUT:
          this.$dialog.message.error('The request to get user location timed out.', {
            position: 'top-center'
          })
          break
        case error.UNKNOWN_ERROR:
          this.$dialog.message.error('An unknown error occurred.', {
            position: 'top-center'
          })
          break
      }
    }
  }
}
</script>

<style>
.theme--light.v-subheader {
  font-size: 1.3em;
  color: black;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/create-1.vue